<div class="account-shell__content">
  <div class="row">
    <div class="pg-wrapper">
      <div class="account-shell__content-wrapper"
        ngClass="{{(deviceValue | async) === DTypes.Mobile ? '' : 'pl-3 pr-3'}}">

        <div class="performers-edit__content performers-create__content">
          <div class="performers-create__content-wrapper">

        <p class="ui-input__error performers-edit__global-error performers-create__global-error" *ngIf="globalError">
          {{ globalError }}
        </p>

        <p class="txt-caption performers-create__global-loading" *ngIf="editProfileLoading">Загрузка профиля...</p>

        <form *ngIf="!editProfileLoading" [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off" class="performers-create__form">
          <div class="performers-create__field performers-create__publish-toggle" id="performers-edit-field-published">
            <div class="performers-create__toggle-wrap">
              <p-inputSwitch
                [ngModel]="editIsPublished"
                (onChange)="onToggleEditPublish()"
                [ngModelOptions]="{standalone: true}"
                [disabled]="publishToggleLoading">
              </p-inputSwitch>
              <span class="performers-edit__toggle-label">{{ editIsPublished ? 'Опубликована' : 'Скрыта' }}</span>
            </div>
          </div>
          
          <div class="performers-create__content-subtitle"
            ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'text-center' : ''}}">
            <h5>Общая информация</h5>
          </div>

          <div class="grid"
            ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'flex-column align-items-center performers-create__first-grid' : 'align-items-start'}}">

            <div class="col-4 col-sm-12"
              id="performers-edit-field-cityId"
              ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'performers-create__first-grid-col pl-2 pr-2' : 'pl-0 pr-2'}}">
              <div class="ui-input__placeholder">
                <p>Город</p>
                <span class="require">*</span>
              </div>
              <p-dropdown
                optionLabel="name"
                [filter]="true"
                [options]="Cities"
                [(ngModel)]="CitySelected"
                [ngModelOptions]="{standalone: true}"
                [styleClass]="form.get('cityId').invalid && form.get('cityId').touched ? 'p-dropdown__bulletins error' : 'p-dropdown__bulletins'"
                (onChange)="onCityDropdownChange()"
                filterPlaceholder="Поиск города..."
                emptyFilterMessage="Ничего не нашли...">
              </p-dropdown>
            </div>

            <div class="col-4 col-sm-12"
              id="performers-edit-field-name"
              ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'performers-create__first-grid-col pl-2 pr-2' : 'pl-2 pr-2'}}">
              <div class="ui-input__placeholder">
                <p>Имя / псевдоним</p>
                <span class="require">*</span>
              </div>
              <div class="ui-input ui-input__text" [class.error]="form.get('name').invalid && form.get('name').touched">
                <input type="text" formControlName="name" placeholder="Руки вверх" maxlength="200">
              </div>
              <p class="ui-input__error" *ngIf="form.get('name').invalid && form.get('name').touched">
                Обязательное поле, от 1 до 200 символов
              </p>
            </div>

            <div class="col-4 col-sm-12"
              id="performers-edit-field-slug"
              ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'performers-create__first-grid-col pl-2 pr-2' : 'pl-2 pr-2'}}">
              <div class="ui-input__placeholder">
                <p>Адрес страницы</p>
                <span class="require">*</span>
              </div>
              <div class="performers-create__slug-readonly">
                <div class="ui-input ui-input__text performers-create__slug-input-wrap">
                  <input type="text" [value]="form.get('slug').value" readonly />
                  <button type="button" class="performers-create__slug-edit-icon" (click)="openSlugEditDialog()" [attr.title]="'Изменить slug'" [attr.aria-label]="'Изменить slug'">
                    <i class="pi pi-pencil"></i>
                  </button>
                  <button type="button" class="performers-create__slug-copy-icon" (click)="onCopySlugLink()" [attr.title]="'Скопировать ссылку'" [attr.aria-label]="'Скопировать ссылку'">
                    <i class="pi pi-copy"></i>
                  </button>
                </div>
                <p class="txt-caption performers-create__slug-preview">
                  {{ slugPreviewUrl || 'muzrus.com/' }}
                  <span class="performers-edit__slug-copy-msg" *ngIf="slugLinkCopied">Ссылка скопирована</span>
                </p>
              </div>
            </div>
          </div>

          <div class="performers-create__field performers-create__field--gap-top" id="performers-edit-field-biography">
            <div class="ui-input__placeholder">
              <p>Биография</p>
              <p class="error-holder" *ngIf="form.get('biography').invalid && form.get('biography').touched">
                {{ form.get('biography').errors?.maxlength ? 'Не более 5000 символов' : '' }}
              </p>
            </div>
            <div class="ui-input ui-input__text" [class.error]="form.get('biography').invalid && form.get('biography').touched">
              <textarea
                placeholder="Расскажите о вас"
                formControlName="biography"
                maxlength="5000"
                rows="5"></textarea>
            </div>
            <p class="pt-1 txt-helper">Доступно символов для ввода: {{ biographyLimit }}</p>
          </div>

          <div class="performers-create__field" id="performers-edit-field-genreIds">
            <div class="ui-input__placeholder">
              <p>Жанр или стиль</p>
              <span class="require">*</span>
            </div>
            <div class="ui-input ui-input__text">
              <div class="ui-input__cup cta ui-scroll-horizontal" (click)="openGenreSearch()"
                [class.error]="form.get('genreIds').invalid && form.get('genreIds').touched">
                <span *ngIf="!GenresSelected.length">
                  Выбрать жанр или стиль
                </span>
                <div class="grid align-items-center flex-nowrap" *ngIf="GenresSelected.length">
                  <ng-container *ngFor="let genre of GenresSelected">
                    <p-chip [label]="genre.name" styleClass="input__chip"></p-chip>
                  </ng-container>
                </div>
              </div>
            </div>
            <p class="ui-input__error" *ngIf="form.get('genreIds').invalid && form.get('genreIds').touched">
              Выберите от 1 до 5 жанров
            </p>
          </div>

          <div class="performers-create__field" id="performers-edit-field-performerTypes"
            [class.error]="showPerformerTypesError">
            <div class="ui-input__placeholder">
              <p>Типы исполнителя</p>
              <span class="require">*</span>
            </div>
            <p class="txt-caption">Можно выбрать не более 3 одновременно</p>
            <p class="ui-input__error" *ngIf="showPerformerTypesError">
              Выберите от 1 до 3 типов исполнителя
            </p>
            <div class="grid performers-create__types-grid mt-4 mb-4"
              ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'flex-column align-items-center' : ''}}">
              <ng-container *ngFor="let t of PerformerTypes">
                <div class="col-3 col-sm-12"
                  ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'pb-2 pl-2 pr-2' : 'pb-4 pr-2'}}">
                  <div class="ui-checkbox" [class.disabled]="isPerformerTypeDisabled(t.value)">
                    <input [id]="'performerType_edit_' + t.value" type="checkbox"
                      [checked]="isPerformerTypeSelected(t.value)"
                      [disabled]="isPerformerTypeDisabled(t.value)"
                      (change)="togglePerformerType(t.value)">
                    <label [attr.for]="'performerType_edit_' + t.value">
                      <span class="ui-checkbox__text">{{ t.name }}</span>
                    </label>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>

          <div class="performers-create__field" id="performers-edit-field-hashtagsRaw">
            <div class="ui-input__placeholder">
              <p>Хештеги</p>
            </div>
            <p class="txt-caption mb-4">До 10 штук, каждый от 3 до 20 символов включительно. Например: #rock #house</p>
            <div class="ui-input ui-input__text">
              <input type="text" formControlName="hashtagsRaw" placeholder="#rock #house" (input)="onHashtagsInput()" (blur)="onHashtagsBlur()">
            </div>
            <p class="ui-input__error" *ngIf="showHashtagLimitMessage">Допустимо не более 10 хештегов</p>
            <p class="ui-input__error" *ngIf="form.get('hashtags').invalid && form.get('hashtags').touched && !showHashtagLimitMessage">Каждый хештег: от 3 до 20 символов (латинские буквы, цифры, подчёркивание)</p>
          </div>

          <div class="performers-create__content-subtitle mt-8"
            ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'text-center' : ''}}">
            <h5>Ссылки на соцсети</h5>
          </div>

          <div class="performers-create__field" id="performers-edit-field-socialLinks">
            <div formArrayName="socialLinks">
              <div *ngFor="let c of socialLinksArray.controls; let i = index; trackBy: trackByIndex" [formGroupName]="i" class="performers-create__social-row"
                ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'performers-create__first-grid-col' : ''}}">
                <div class="performers-create__social-platform"
                  ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'pl-2 pr-2' : 'pr-2'}}">
                  <p-dropdown
                    [options]="SocialPlatforms"
                    optionLabel="name"
                    optionValue="value"
                    [formControl]="c.get('platform')"
                    styleClass="p-dropdown__bulletins"
                    [placeholder]="'Платформа'"
                    [showClear]="false">
                    <ng-template let-platform pTemplate="item">
                      <div class="performers-create__platform-option">
                        <span *ngIf="getPlatformIcon(platform.value).type === 'font'" [class]="getPlatformIcon(platform.value).iconClass" class="performers-create__platform-icon-font">
                          <span class="path1"></span><span class="path2"></span><span class="path3" *ngIf="getPlatformIcon(platform.value).paths >= 3"></span><span class="path4" *ngIf="getPlatformIcon(platform.value).paths >= 4"></span>
                        </span>
                        <img *ngIf="getPlatformIcon(platform.value).type === 'svg'" [src]="getPlatformIcon(platform.value).src" class="performers-create__platform-icon-img" alt="">
                        <span class="performers-create__platform-name">{{ platform.name }}</span>
                      </div>
                    </ng-template>
                    <ng-template let-platform pTemplate="selectedItem">
                      <div class="performers-create__platform-option" *ngIf="platform; else platformPlaceholder">
                        <span *ngIf="getPlatformIcon(platform.value).type === 'font'" [class]="getPlatformIcon(platform.value).iconClass" class="performers-create__platform-icon-font">
                          <span class="path1"></span><span class="path2"></span><span class="path3" *ngIf="getPlatformIcon(platform.value).paths >= 3"></span><span class="path4" *ngIf="getPlatformIcon(platform.value).paths >= 4"></span>
                        </span>
                        <img *ngIf="getPlatformIcon(platform.value).type === 'svg'" [src]="getPlatformIcon(platform.value).src" class="performers-create__platform-icon-img" alt="">
                        <span class="performers-create__platform-name">{{ platform.name }}</span>
                      </div>
                      <ng-template #platformPlaceholder>Платформа</ng-template>
                    </ng-template>
                  </p-dropdown>
                </div>
                <div class="performers-create__social-url"
                  ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'pl-2 pr-2' : 'pl-2 pr-2'}}">
                  <div class="ui-input ui-input__text" [class.error]="c.get('url').invalid && c.get('url').touched">
                    <input type="url" formControlName="url" placeholder="https://">
                  </div>
                </div>
                <div class="performers-create__social-remove">
                  <button type="button" class="ui-buttons ui-buttons__light-small performers-create__social-remove-btn" (click)="removeSocialLink(i)" [attr.aria-label]="'Удалить ссылку'">
                    <i class="pi pi-times"></i>
                  </button>
                </div>
              </div>
            </div>
            <button type="button" class="ui-buttons ui-buttons__light-small performers-create__add-link-btn mt-2" (click)="addSocialLink()">Добавить ссылку</button>
          </div>

          <div class="performers-create__content-subtitle mt-8"
            ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'text-center' : ''}}">
            <h5>Фото и видео</h5>
          </div>

          <div class="performers-create__field" formArrayName="videoLinks" id="performers-edit-field-videoLinks">
            <div class="grid"
              ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'flex-column' : 'align-items-end'}}">
              <div class="col-6 col-sm-12 performers-create__video-col"
                ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'pb-2' : 'pr-2'}}">
                <div class="ui-input__placeholder">
                  <p>Ссылка на видео VK</p>
                </div>
                <div class="ui-input ui-input__text" [class.error]="videoLinksArray.controls[0].invalid && videoLinksArray.controls[0].touched">
                  <div class="ui-input__helper">
                    <div class="ui-input__helper-icon performers-create__vk-video-icon">
                      <img src="assets/images/icons/vk-video.svg" alt="VK Video" />
                    </div>
                  </div>
                  <input type="url" [formControlName]="0" placeholder="https://vk.com/video123456789_123456789">
                </div>
                <div class="performers-create__video-error">
                  <p class="ui-input__error" *ngIf="videoLinksArray.controls[0].invalid && videoLinksArray.controls[0].touched">
                    Укажите ссылку на VK видео
                  </p>
                </div>
              </div>
              <div class="col-6 col-sm-12 performers-create__video-col"
                ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'performers-create__video-second-col pb-2' : 'pl-2 pr-0'}}">
                <div class="ui-input__placeholder">
                  <p>Ссылка на дополнительное видео VK</p>
                </div>
                <div class="ui-input ui-input__text" [class.error]="videoLinksArray.controls[1].invalid && videoLinksArray.controls[1].touched">
                  <div class="ui-input__helper">
                    <div class="ui-input__helper-icon performers-create__vk-video-icon">
                      <img src="assets/images/icons/vk-video.svg" alt="VK Video" />
                    </div>
                  </div>
                  <input type="url" [formControlName]="1" placeholder="https://vk.com/video123456789_123456789">
                </div>
                <div class="performers-create__video-error">
                  <p class="ui-input__error" *ngIf="videoLinksArray.controls[1].invalid && videoLinksArray.controls[1].touched">
                    Укажите ссылку на VK видео
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="performers-create__field">
            <div class="ui-input__placeholder">
              <p>Основное фото</p>
            </div>
            <div class="performers-edit__main-photo" (click)="openMainPhotoEditDialog()">
              <img *ngIf="MainPhotoPreview" [src]="MainPhotoPreview" alt="Превью" class="performers-edit__main-photo-img" />
              <div *ngIf="!MainPhotoPreview" class="performers-edit__main-photo-placeholder">
                <i class="pi pi-image"></i>
                <span>Нет фото</span>
              </div>
              <button type="button" class="performers-edit__photo-edit-btn" (click)="openMainPhotoEditDialog(); $event.stopPropagation()" [attr.title]="'Редактировать основное фото'" [attr.aria-label]="'Редактировать основное фото'">
                <i class="pi pi-pencil"></i>
              </button>
            </div>
          </div>

          <div class="performers-create__field">
            <div class="ui-input__placeholder">
              <p>Фотогалерея</p>
            </div>
            <div class="performers-edit__gallery-block">
              <div *ngIf="GalleryPreviews.length" class="performers-edit__gallery-thumbs">
                <img *ngFor="let src of GalleryPreviews.slice(0, 4)" [src]="src" alt="Фото" class="performers-edit__photo-thumb" />
              </div>
              <button type="button" class="ui-buttons ui-buttons__light-small performers-edit__gallery-edit-btn" (click)="openGalleryEditDialog()">
                <i class="pi pi-pencil"></i>
                Редактировать фотогалерею
              </button>
            </div>
          </div>

          <div class="performers-create__field" id="performers-edit-field-playlistLink">
            <div class="ui-input__placeholder">
              <p>Ссылка на плейлист</p>
              <span class="require">*</span>
            </div>
            <div class="ui-input ui-input__text" [class.error]="form.get('playlistLink').invalid && form.get('playlistLink').touched">
              <input type="url" formControlName="playlistLink" placeholder="https://vk.com/music/playlist/299117..." title="Оформите плейлист с вашими хитами и укажите ссылку на VK">
            </div>
            <p class="ui-input__error" *ngIf="form.get('playlistLink').invalid && form.get('playlistLink').touched">
              Укажите ссылку на плейлист (обязательное поле).
            </p>
          </div>

          <ng-container *ngIf="bookingForm && editPerformerId">
            <div class="performers-create__content-subtitle mt-8">
              <h5>Букинг</h5>
            </div>
            <p class="txt-caption" *ngIf="bookingSettingsLoading">Загрузка настроек бронирования...</p>
            <p class="ui-input__error" *ngIf="bookingGlobalError">{{ bookingGlobalError }}</p>
            <div [formGroup]="bookingForm" *ngIf="!bookingSettingsLoading">
              <div class="performers-create__booking-fee">
                <div class="performers-create__booking-fee-head ui-input__placeholder">
                  <p>Гонорар</p>
                  <span class="require">*</span>
                  <p class="error-holder" *ngIf="bookingForm.errors?.bookingRateRequired && bookingFormSubmitted">
                    Укажите сумму за час, сумму за сет или описание (договорная).
                  </p>
                </div>
                <div class="grid">
                  <div class="col-6 col-sm-12">
                    <div class="ui-input__placeholder"><p>Сумма за час, руб</p></div>
                    <div class="ui-input ui-input__text"><input type="number" formControlName="pricePerHour" min="1" step="1" /></div>
                  </div>
                  <div class="col-6 col-sm-12">
                    <div class="ui-input__placeholder"><p>Сумма за сет, руб</p></div>
                    <div class="ui-input ui-input__text"><input type="number" formControlName="pricePerSet" min="1" step="1" /></div>
                  </div>
                </div>
              </div>
              <div class="performers-create__field">
                <div class="ui-input__placeholder"><p>Договорная</p></div>
                <div class="ui-input ui-input__text">
                  <textarea formControlName="bookingDescription" class="performers-create__textarea-booking" maxlength="300" rows="3"></textarea>
                </div>
                <p class="pt-1 txt-helper">Доступно символов: {{ bookingDescriptionLimit }}</p>
              </div>
              <div class="performers-create__field">
                <div class="ui-input__placeholder"><p>Текст доступности букинга</p></div>
                <div class="ui-input ui-input__text">
                  <input type="text" formControlName="bookingAvailabilityText" placeholder="Доступен с четверга по субботу" maxlength="100" />
                </div>
              </div>
              <button type="button" class="ui-buttons ui-buttons__blue-small mb-4" (click)="onSaveBookingSettings()" [disabled]="bookingSubmitLoading || bookingForm.invalid">
                {{ bookingSubmitLoading ? 'Сохранение...' : 'Сохранить настройки букинга' }}
              </button>
            </div>
          </ng-container>

          <div class="performers-create__actions">
            <button type="button" class="ui-buttons ui-buttons__light-large" (click)="onPreview()" [disabled]="submitLoading">
              Предпросмотр
            </button>
            <button type="submit" class="ui-buttons ui-buttons__blue-large" [disabled]="form.invalid || submitLoading">
              Сохранить изменения
            </button>
          </div>
        </form>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<p-confirmDialog key="unsaved-form" appendTo="body" styleClass="p-dialog__confirm"></p-confirmDialog>
